import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  isUserLoggedIn: false,
  accessToken: null,
  refreshToken: null,
  profileData: null,
  error: null,
  success: false,
};

// Check if the user is logged in based on sessionStorage
const storedAccessToken = sessionStorage.getItem("accessToken");
const storedRefreshToken = sessionStorage.getItem("refreshToken");

const initialAuthState = storedAccessToken && storedRefreshToken
  ? {
      loading: false,
      isUserLoggedIn: false,
      accessToken: storedAccessToken,
      refreshToken: storedRefreshToken,
      error: null,
      langauges: [],
      profileData:null,
      city_list:[],
      success: false,
    }
  : initialState;

const userAuthSlice = createSlice({
  name: "userAuth",
  initialState: initialAuthState,
  reducers: {
    userLoginSuccess: (state, action) => {
      const { accessToken, refreshToken } = action.payload;
      state.loading = false;
      state.isUserLoggedIn = true;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      state.error = null;

      // Store tokens in sessionStorage
      localStorage.setItem("jayeek_accessToken", accessToken);
      localStorage.setItem("jayeek_refreshToken", refreshToken);
    },

    setProfileData: (state, action) => {

      console.log("afsaag",action?.payload)
      state.loading = false;
      state.profileData = action.payload;
      state.error = null;
    },


    setCities: (state, action) => {
      state.loading = false;
      state.city_list = action.payload;
      state.error = null;
    },
    
    setlangauges: (state, action) => {
      state.langauges = action.payload;
      state.error = null;
    },
    userLogout: (state) => { 
      
      localStorage.removeItem("jayeek_accessToken");
      localStorage.removeItem("jayeek_refreshToken");
      state.isUserLoggedIn =  false,
      state.loading = false;
    },
  },
});

export const { userLoginSuccess, userLogout, userSetIslogin , setlangauges , setProfileData , setCities} = userAuthSlice.actions;
export default userAuthSlice.reducer;
